export default store => next => action => {
    console.groupCollapsed(`[Dispatch] ${action.type}`);
    console.log(action);
    console.groupCollapsed('Dispatch Trace');
    console.trace('Callstack');
    console.groupEnd();
    console.groupEnd();
    return next(action);
}
